import { format } from 'date-fns';

const prevBindFn = (date) => format(new Date(date), 'MMM dd, yyyy');

export default (props, vars) =>
  typeof prevBindFn === 'function'
    ? prevBindFn(vars?.['defaultbox145']?.['item']?.['completion_date'])
    : prevBindFn;
